/**
 * @file
 * Code highlight script.
 */

(function codeHighlightScript($, Drupal) {
  'use strict';

  /*
   * Code Highlight.
   */
  Drupal.behaviors.codeHighlightInit = {
    attach: function () {
      hljs.initHighlightingOnLoad(); // eslint-disable-line no-undef
    }
  };
}(jQuery, Drupal));
